import Vue from 'vue'

// Create the event hub to allow a direct communication between components
const eventHub = new Vue()

export default eventHub
